import { AuthCard } from '@authentication/components/AuthCard';

import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoginRequest from '@authentication/models/login.request.dto';
import TextFieldForm from '@atoms/TextFieldForm';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getItem } from '@/lib/storageUtil';
import {
  ButtonLogin,
  ErrorLoginTypography,
  LabelField,
} from './logout-card.styled';
import React, { useMemo } from 'react';
import useLogoutMutation from '@authentication/mutations/logoutMutation';
import { LocalStorageKeys } from '@authentication/constants';

const initialValues = {
  username: '',
  password: '',
  storeId: undefined,
};

const loginSchema = Yup.object().shape({
  username: Yup.string().email('invalid email').required('required'),
  password: Yup.string().required('required'),
  storeId: Yup.number().required('required'),
});

const LogoutCard = () => {
  const { t } = useTranslation();
  const { mutate: loginMutate, isError } = useLogoutMutation();
  const storedUserId = getItem(LocalStorageKeys.STORE_ID);

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => event.preventDefault();

  const methods = useForm<LoginRequest>({
    mode: 'onChange',
    defaultValues: useMemo(() => initialValues, [initialValues]),
    resolver: yupResolver(loginSchema) as any,
  });

  const { formState, handleSubmit, setValue } = methods;
  const { isDirty } = formState;

  const onSubmit = handleSubmit((data) => {
    loginMutate(data);

    localStorage.clear();
  });

  React.useEffect(() => {
    setValue('storeId', Number(storedUserId));
  }, []);

  return (
    <AuthCard title="Se déconnecter de Triangle Store RH">
      <FormProvider {...methods}>
        <form onSubmit={onSubmit} autoComplete="off">
          <Stack gap={1}>
            {/* <LabelField>Store</LabelField>
            <Select
              withBorder
              options={
                storesData?.data.items?.map((item: any) => ({
                  label: item.name,
                  value: String(item.id),
                })) ?? []
              }
              onChange={(e) => setValue('storeId', Number(e.target.value))}
            /> */}

            <LabelField>Adresse mail ou nom d’utilisateur</LabelField>
            <TextFieldForm
              name="username"
              fullWidth
              noBorder
              placeholder={t('EMAIL') ?? ''}
            />
            <LabelField>Mot de passe</LabelField>

            <OutlinedInput
              name="password"
              placeholder="Mot de passe"
              type={showPassword ? 'text' : 'password'}
              required
              sx={{
                paddingBlock: '8px',
                paddingRight: '16px',
              }}
              fullWidth
              onChange={(e) => {
                setValue('password', e.target.value);
              }}
              size="small"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />

            {isError && (
              <ErrorLoginTypography>
                e-mail ou mot de passe incorrect
              </ErrorLoginTypography>
            )}
            <ButtonLogin disabled={!isDirty} type="submit">
              Se déconnecter
            </ButtonLogin>
          </Stack>
        </form>
      </FormProvider>
    </AuthCard>
  );
};

export default LogoutCard;
